module.exports = __webpack_public_path__ + "img/top-services.45ea674b.png";